// extracted by mini-css-extract-plugin
module.exports = {"gradientColors":"#A51D44 #DB1C4C #F05B31 #2FBA9A #258469"};